import { render } from "./AwningActuator.vue?vue&type=template&id=2ccb44ae&ts=true"
import script from "./AwningActuator.vue?vue&type=script&lang=ts"
export * from "./AwningActuator.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__